module.exports = __webpack_public_path__ + "static/media/8_heures.c3309faf.mp3";